<template>
    <component :is="loadingType"></component>
</template>

<script>
import AvatarTwoLine from './components/AvatarTwoLine.vue'
import AvatarThreeLine from './components/AvatarThreeLine.vue'
export default {
    components :{
        AvatarTwoLine,
        AvatarThreeLine
    },
    props : {
        loadingType : {
            type : String,
            default : 'avatar-two-line'
        }
    }
}
</script>